import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OdataEntityField } from "services/models/odata/odataEntityField";
import { EmployeeModel } from "services/models/employee.model";
import { EmployeeService } from "services/corporate/employee.service";
import { ListAbstract } from 'app/views/pages/abstract/list-abstract';
import { FeedbackFormComponent, FeedbackFormMode } from '../feedback-form/feedback-form.component';


@Component({
  selector: 'app-sent-feedback-list',
  templateUrl: './sent-feedback-list.component.html',
  styleUrls: ['./sent-feedback-list.component.scss']
})
export class SentFeedbackListComponent extends ListAbstract<EmployeeModel, EmployeeService> implements OnInit {

  title: string = 'Feedbacks enviados';
  emitQueryMethod = false;
  isLoading: boolean = false;
  requestFeedback: EmployeeModel = new EmployeeModel();

  fields = [
    { field: "sender", alias: "Remetente" },
    { field: "date", alias: "Data" },
  ].map((x) => x as OdataEntityField);

  fieldsRequest = [
    { field: "sender", alias: "Para" },
    { field: "date", alias: "Data" },
  ].map((x) => x as OdataEntityField);

  customActions = [
    {
      id: "action-view",
      icon: "feather-edit",
      label: "Visualizar",
      class: "text-primary",
      callAction: (obj: EmployeeModel) => this.handleViewFeedback(obj),
    },
  ];

  customActionsRequest = [
    {
      id: "action-view",
      icon: "feather-arrow-left",
      label: "Realizar feedback",
      class: "text-primary",
      callAction: (obj: EmployeeModel) => this.handleRequestFeedback(obj),
    },

  ];

  constructor(
    public service: EmployeeService,
    private ngbModal: NgbModal,
  ) {
    super(service);
    this.canEdit = false;
  }

  ngOnInit(): void {
  }

  public handleRequestFeedback(obj?: EmployeeModel): void {
    this.requestFeedback = obj ?? this.requestFeedback;
    const modalRef = this.ngbModal.open(FeedbackFormComponent, {
      animation: false,
      windowClass: 'feedback-form-drawer-modal',
      backdropClass: 'feedback-form-drawer-modal-backdrop',
      backdrop: 'static',
      keyboard: true,
      size: 'xl',
    });
    modalRef.componentInstance.mode = FeedbackFormMode.Create;
    modalRef.componentInstance.requestFeedback = this.requestFeedback;
    modalRef.result.then(
      (result: boolean) => { if (result) this.query(); },
      (reason: boolean) => { if (reason) this.query(); }
    );
  }

  public handleViewFeedback(obj: EmployeeModel): void {
    const modalRef = this.ngbModal.open(FeedbackFormComponent, {
      animation: false,
      windowClass: 'feedback-form-drawer-modal',
      backdropClass: 'feedback-form-drawer-modal-backdrop',
      backdrop: 'static',
      keyboard: true,
      size: 'xl',
    });
    modalRef.componentInstance.mode = FeedbackFormMode.View;
    modalRef.componentInstance.feedbackView = obj;
    modalRef.result.then(
      (result: boolean) => { if (result) this.query(); },
      (reason: boolean) => { if (reason) this.query(); }
    );
  }

}
